import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { gerar_grade_horaria, IGradeHoraria } from '../utils/generators/grade_horaria.generator';
import { usePeriodosQuery } from '../graphql/queries/periodos.query';
import { useGradePageLazyQuery } from '../graphql/queries/grade_page.query';
import { PeriodosQuery_periodos } from '../graphql/queries/__generated__/PeriodosQuery';
import { RootState } from '../../../../infrastructure/redux/store';

import { Container } from '../components/container/styles';
import { GradeDisciplinas, IGradeDisciplinas } from '../components/grade_horaria';
import { CalendarioHorarios } from '../components/calendario_horarios';
import { ButtonSelect } from '../../shared/components/button_select';
import { Loading } from '../../shared/components/layout_components/loading';
import { ItemProps } from '../../shared/components/button_select/modal';
import { Button } from '../../shared/components/form_components/button';
import { FormGroup } from '../../shared/components/form_components/group';

const GradePage: React.FC = () => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const [gradeHoraria, setGradeHoraria] = useState<IGradeHoraria[]>([]);
  const [disciplinas, setDsiciplinas] = useState<IGradeDisciplinas[]>([]);
  const [periodo, setPeriodo] = useState<PeriodosQuery_periodos>();
  const [periodosModal, setPeriodosModal] = React.useState(false);

  const [params] = useSearchParams();

  const { data: dados_periodos } = usePeriodosQuery();
  const [obter_dados_grade, { data: dados_grade }] = useGradePageLazyQuery();

  const alternar_modal = {
    periodos: () => setPeriodosModal(!periodosModal),
  };

  const selecionar = {
    periodo: (item: ItemProps<PeriodosQuery_periodos>) => {
      setPeriodo(item.data);
      alternar_modal.periodos();
    },
  };

  const obter_semestre = () => {
    if (periodo) {
      if (dados_periodos) {
        const periodos_mesmo_ano = dados_periodos.periodos.filter(
          (p) => new Date(p.dat_inicio).getFullYear() === new Date(periodo.dat_inicio).getFullYear()
        );

        if (periodos_mesmo_ano.length <= 1) return 1;

        const [primeiro_periodo] = periodos_mesmo_ano;

        return periodo === primeiro_periodo ? 1 : 2;
      }

      return 0;
    }
  };

  const obter_ano = () => {
    if (periodo) {
      return new Date(periodo.dat_inicio).getFullYear();
    }
  };

  useEffect(() => {
    document.title = 'SisIEC - Grade Horária';
  }, []);

  useEffect(() => {
    const id_oferta = Number(params.get('id_oferta'));
    const id_turma = Number(params.get('id_turma'));

    if (periodo && id_oferta && id_turma) {
      obter_dados_grade({
        variables: {
          id_turma,
          id_oferta,
          dat_inicio: new Date('1990-01-01').toJSON(),
          dat_fim: periodo.dat_fim,
        },
      });
    }
  }, [periodo]);

  useEffect(() => {
    const id_periodo = Number(params.get('id_periodo'));

    if (dados_periodos && id_periodo) {
      const periodo = dados_periodos.periodos.find((periodo) => periodo.id_periodo === id_periodo);
      setPeriodo(periodo);
    }
  }, [dados_periodos]);

  useEffect(() => {
    if (dados_grade && periodo) {
      document.title =
        'SisIEC - Grade Horária - ' +
        `${dados_grade.oferta.curso?.dsc_nome_curso} ` +
        `${dados_grade.oferta.num_oferta}.${dados_grade.turma.num_turma} ` +
        `(${dados_grade.oferta.num_semestre}/${dados_grade.oferta.num_ano})`;

      gerar_grade_horaria({
        alocacoes_professor: dados_grade.alocacoes_professores,
        projetos_pedagogico: dados_grade.projetos_pedagogicos,
        horario: dados_grade.turma.horario || dados_grade.horarios[0],
        feriados: dados_grade.feriados,
        periodo,
      })
        .then(({ grade_horaria, disciplinas }) => {
          setDsiciplinas(disciplinas);
          setGradeHoraria(grade_horaria);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [dados_grade]);

  return dados_grade ? (
    <Container scroll column wide_padding>
      {dados_periodos && (
        <FormGroup>
          <Button color={theme.colors.primary} onClick={() => window.print()}>
            Imprimir
          </Button>

          <ButtonSelect
            modalTitle={'Período'}
            modalVisible={periodosModal}
            onClick={alternar_modal.periodos}
            onSelectItem={selecionar.periodo}
            backgroundColor={theme.colors.primary}
            textColor={theme.colors.textPrimary}
            width={'200px'}
            items={dados_periodos.periodos.map((p) => ({
              id: p.id_periodo,
              label: p.dsc_periodo,
              data: p,
            }))}
          >
            {periodo?.dsc_periodo || 'Selecionar período'}
          </ButtonSelect>
        </FormGroup>
      )}

      <GradeDisciplinas
        disciplinas={disciplinas}
        oferta={dados_grade.oferta}
        turma={dados_grade.turma}
        periodo={periodo}
        num_grade={`${dados_grade.oferta.num_oferta}.${dados_grade.turma.num_turma}`}
        num_semestre={obter_semestre()}
        num_ano={obter_ano()}
      />
      {gradeHoraria.map((mes) => (
        <CalendarioHorarios
          key={mes.nome_mes}
          mes={mes.nome_mes}
          colunas={mes.colunas}
          linhas={mes.linhas}
        />
      ))}
    </Container>
  ) : (
    <Loading />
  );
};

export { GradePage };
